import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
/*import notificationimg from './../../../assets/images/user/user-xs-01.jpg';*/
import Swal from 'sweetalert2';
import * as signalR from "@microsoft/signalr";
import { jwtDecode } from "jwt-decode";
import { API_BASE_URL, HUB_URL } from "../../../apiConfig";

const Headerdash = ({ toggleSidebar }) => {
  const location = useLocation();
  const [Name, setName] = useState("");  //Add by Jinal
  const [userData, setUserData] = useState({ cmsid: "", name: "", email: "", phone: "" });
  const [balance, setBalance] = useState(0);
  const [notifications, setNotifications] = useState([]);
  const [userRole, setUserRole] = useState(null);
  const unreadCount = notifications.filter(n => !n.isRead).length;


  useEffect(() => {

    fetchWalletBalance();

    // Check if there is an addedAmount in the URL query string
    const params = new URLSearchParams(window.location.search);
    const addedAmount = params.get('addedAmount');
    if (addedAmount) {
      const amountNum = parseFloat(addedAmount);
      if (amountNum === 5000) {
        Swal.fire({
          title: "Recharge Successful!",
          html: "₹5,000 has been added to your wallet.<br/><b>Bonus ₹500 credited successfully!</b>",
          icon: "success",
          confirmButtonColor: "#9e6de0"
        });
      } else {
        Swal.fire({
          title: "Recharge Successful!",
          text: `₹${addedAmount} has been added to your wallet.`,
          icon: "success",
          confirmButtonColor: "#9e6de0"
        });
      }
      // Clean up query param so refresh doesn't alert again
      const url = new URL(window.location);
      url.searchParams.delete('addedAmount');
      window.history.replaceState({}, document.title, url.pathname + url.search);
    }
    // Listen for balance update events
    const handleWalletUpdate = () => {
      console.log("Received balanceUpdated event.");
      fetchWalletBalance();
    };

    const token = localStorage.getItem("authToken");
    if (token) {
      try {
        const decodedToken = jwtDecode(token);
        setUserRole(parseInt(decodedToken.RoleBaseId));
      } catch (error) {
        console.error("Error decoding token:", error);
      }
    }

    window.addEventListener("balanceUpdated", handleWalletUpdate);

    return () => {
      window.removeEventListener("balanceUpdated", handleWalletUpdate);
    };
  }, []);

  useEffect(() => {
    const handleTriggerAddMoney = () => {
      handleAddMoney();
    };
    window.addEventListener("triggerAddMoney", handleTriggerAddMoney);
    return () => {
      window.removeEventListener("triggerAddMoney", handleTriggerAddMoney);
    };
  }, [userData]);

  useEffect(() => {            //Below add by Jinal
    const fetchUserProfile = async () => {
      try {
        const authToken = localStorage.getItem("authToken");
        if (!authToken) return;

        const response = await fetch(`${API_BASE_URL}/UpdateProfile/GetProfile`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${authToken}`,
            "Content-Type": "application/json",
          },
        });

        if (!response.ok) {
          console.error("Failed to fetch user profile");
          return;
        }

        const data = await response.json();
        console.log("User Profile Data:", data); // Debugging

        setName(data.name); // Ensure the correct case
        setUserData({
          cmsid: data.cmsid,
          name: data.name,
          email: data.email,
          phone: data.number?.toString() || "", // Ensure phone is a string
        });
      } catch (error) {
        console.error("Error fetching user profile:", error);
      }
    };

    fetchUserProfile();
  }, []);

  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        const authToken = localStorage.getItem("authToken");
        if (!authToken || userRole !== 1) return;

        const res = await fetch(`${API_BASE_URL}/Notifications/admin`,
          {
            headers: {
              Authorization: `Bearer ${authToken}`,
              "Content-Type": "application/json",
            },
          }
        );

        const data = await res.json();

        setNotifications(
          Array.isArray(data)
            ? data.map(n => ({
              notificationId: n.notificationId || n.NotificationId,
              retailerName: n.retailerName || n.RetailerName,
              formName: n.formName || n.FormName,
              message: n.message || n.Message,
              createdAt: n.createdAt || n.CreatedAt,
              isRead: n.isRead ?? n.IsRead ?? false
            }))
            : []
        );
      } catch (err) {
        console.error("Notification fetch error:", err);
      }
    };

    fetchNotifications();
  }, [userRole]);

  useEffect(() => {
    const handleNotificationRead = (event) => {
      const { id } = event.detail;
      setNotifications(prev => {
        const item = prev.find(n => n.notificationId === id);
        if (item && item.isRead) return prev;
        return prev.map(n => n.notificationId === id ? { ...n, isRead: true } : n);
      });
    };

    window.addEventListener("notificationRead", handleNotificationRead);
    return () => window.removeEventListener("notificationRead", handleNotificationRead);
  }, []);

  useEffect(() => {
    const authToken = localStorage.getItem("authToken");
    if (!authToken || userRole !== 1) return;

    const connection = new signalR.HubConnectionBuilder()
      .withUrl(HUB_URL, {
        accessTokenFactory: () => authToken
      })
      .withAutomaticReconnect()
      .build();

    connection.start();

    connection.on("NewNotification", data => {
      console.log("New SignalR Notification:", data);
      const normalized = {
        notificationId: data.notificationId || data.NotificationId,
        retailerName: data.retailerName || data.RetailerName,
        formName: data.formName || data.FormName,
        message: data.message || data.Message,
        createdAt: data.createdAt || data.CreatedAt,
        isRead: false
      };
      setNotifications(prev => [normalized, ...prev]);
    });

    return () => {
      if (connection) {
        connection.stop().catch(err => console.error("SignalR stop error:", err));
      }
    };
  }, [userRole]);


  const markAsRead = async (id) => {
    if (!id) return;

    // Optimistically update UI
    setNotifications(prev =>
      prev.map(n => n.notificationId === id ? { ...n, isRead: true } : n)
    );

    try {
      const authToken = localStorage.getItem("authToken");
      if (!authToken) return;

      const response = await fetch(`${API_BASE_URL}/Notifications/mark-read/${id}`, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${authToken}`
        }
      });

      if (response.ok) {
        window.dispatchEvent(new CustomEvent("notificationRead", { detail: { id } }));
      } else {
        console.error("Failed to mark as read in DB");
      }
    } catch (error) {
      console.error("Error marking notification as read:", error);
    }
  };





  //   useEffect(() => {
  //   const fetchNotifications = async () => {
  //     try {
  //       const authToken = localStorage.getItem("authToken");
  //       if (!authToken) return;

  //       const response = await fetch(
  //         "http://localhost:5121/api/Notifications/admin",
  //         {
  //           method: "GET",
  //           headers: {
  //             Authorization: `Bearer ${authToken}`,
  //             "Content-Type": "application/json"
  //           }
  //         }
  //       );

  //       if (!response.ok) {
  //         console.error("Failed to fetch notifications");
  //         return;
  //       }

  //       const data = await response.json();
  //       setNotifications(data);
  //     } catch (error) {
  //       console.error("Error loading notifications:", error);
  //     }
  //   };

  //   fetchNotifications();
  // }, []);

  // useEffect(() => {
  //   const authToken = localStorage.getItem("authToken");
  //   if (!authToken) return;

  //   const connection = new signalR.HubConnectionBuilder()
  //     .withUrl("http://localhost:5121/NotificationHub", {
  //       accessTokenFactory: () => authToken
  //     })
  //     .withAutomaticReconnect()
  //     .build();

  //   connection
  //     .start()
  //     .then(() => console.log("SignalR connected"))
  //     .catch(err => console.error("SignalR error:", err));

  //   connection.on("NewNotification", (data) => {
  //     setNotifications(prev => [data, ...prev]);
  //   });

  //   return () => {
  //     connection.stop();
  //   };
  // }, []);


  const handleAddMoney = async () => {
    try {
      const authToken = localStorage.getItem("authToken");
      if (!authToken) {
        Swal.fire("Error", "User not authenticated!", "error");
        return;
      }

      // Show a SweetAlert2 input modal
      const { value: amount } = await Swal.fire({
        title: "Enter the amount",
        input: "number",
        inputPlaceholder: "Minimum ₹100",
        inputAttributes: { min: 100 },
        showCancelButton: true,
        confirmButtonText: "Proceed",
        cancelButtonText: "Cancel",
        inputValidator: (value) => {
          if (!value || isNaN(value) || parseFloat(value) < 100) {
            return "Please enter a valid amount of at least ₹100.";
          }
        },
      });

      if (!amount) return; // If the user cancels

      // Open a new window immediately to prevent popup blocking
      const newWindow = window.open("about:blank", "_blank");
      if (!newWindow) {
        Swal.fire("Error", "Popup blocked! Please allow popups and try again.", "error");
        return;
      }

      // Send request to the backend
      const response = await fetch(`${API_BASE_URL}/PayUPayment/add-money`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${authToken}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          amount: amount,
          productInfo: "WalletRecharge",
          firstName: userData.name,
          email: userData.email,
          phone: userData.phone,
        }),
      });

      const html = await response.text();
      if (response.ok) {
        newWindow.document.open();
        newWindow.document.write(html);
        newWindow.document.close();
      } else {
        newWindow.close();
        Swal.fire("Error", "Failed to initiate payment. Please try again.", "error");
      }
    } catch (error) {
      console.error("Error initiating payment:", error);
      Swal.fire("Error", "An error occurred. Please try again.", "error");
    }
  };


  const fetchWalletBalance = async () => {
    try {
      const authToken = localStorage.getItem("authToken");
      if (!authToken) return;
      const response = await fetch(`${API_BASE_URL}/PayUPayment/get-balance`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${authToken}`,
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        console.error("Failed to fetch wallet balance");
        return;
      }

      const data = await response.json();
      setBalance(data.balance);
    } catch (error) {
      console.error("Error fetching wallet balance:", error);
    }
  };


  const handleLogout = () => {
    localStorage.removeItem("authToken"); // Clear the token
    window.location.href = "/"; // Force page reload to clear cache
  };


  const getPageTitle = () => {
    switch (location.pathname) {
      case '/dashboard':
        return 'Dashboard';
      case '/dashboard/retailers':
        return 'Retailers';
      case '/dashboard/guests':
        return 'Guests';
      case '/dashboard/notifications':
        return 'Notifications';
      case '/dashboard/address-update':
        return 'Address Update';
      case '/dashboard/retailor-transaction-report':
        return 'Retailers Transaction Report';
      case '/dashboard/pay-u-transaction':
        return 'Pay U Transaction';
      case '/dashboard/rise-ticket':
        return 'Rise Ticket';
      case '/dashboard/open-new-ticket':
        return 'Open New Ticket';
      case '/dashboard/close-ticket':
        return 'Close Ticket';
      case '/dashboard/activities':
        return 'Activities';
      case '/dashboard/user-profile':
        return 'User Profile';
      case '/dashboard/chanage-home-content':
        return 'Chanage Home Content';

      case '/dashboard/camp-registration':
        return 'Camp Registration';
      case '/dashboard/name-publication':
        return 'Name Publication';
      case '/dashboard/new-pan-application':
        return 'New PAN Application';
      case '/dashboard/correction-pan-application':
        return 'Correction PAN Application';
      case '/dashboard/pan-object':
        return 'PAN Object';
      case '/dashboard/pan-find':
        return 'Find PAN';
      case '/dashboard/add-applicants':
        return 'Add Applicants';

      case '/dashboard/new-pan-application-report':
        return 'New PAN Application Report';
      case '/dashboard/name-publication-report':
        return 'Name Publication report';
      case '/dashboard/camp-registration-report':
        return 'CAMP Registration Report';
      case '/dashboard/pan-object-report':
        return 'PAN Object Report';
      case '/dashboard/pan-find-report':
        return 'PAN Find Report';
      case '/dashboard/correction-pan-application-report':
        return 'Correction PAN Application Report';
      case '/dashboard/new-address-report':
        return 'New Address Report';

      case '/dashboard/new-pan-application-admin-report':
        return 'New PAN Application Admin Report';
      case '/dashboard/correction-pan-application-admin-report':
        return 'Correction PAN Application Admin Report';
      case '/dashboard/name-publication-admin-report':
        return 'Name Publication Admin Report';
      case '/dashboard/pan-object-admin-report':
        return 'PAN Object Admin Report';
      case '/dashboard/camp-registration-admin-report':
        return 'Camp Registration Admin Report';
      case '/dashboard/pan-find-admin-report':
        return 'Pan Find Admin Report';
      case '/dashboard/new-address-admin-report':
        return 'New Address Report';

      case '/dashboard/new-pan-application-complete-report':
        return 'New PAN Application Complete Report';
      case '/dashboard/correction-pan-application-complete-report':
        return 'Correction PAN Application Complete Report';
      case '/dashboard/name-publication-complete-report':
        return 'Name Publication Complete Report';
      case '/dashboard/pan-object-complete-report':
        return 'PAN Object Complete Report';
      case '/dashboard/camp-registration-complete-report':
        return 'Camp Registration Complete Report';
      case '/dashboard/pan-find-complete-report':
        return 'Pan Find Complete Report';

      default:
        return 'Dashboard'; // Default title if no match
    }
  };
  return (
    <header className="main-header" id="header">
      <nav className="navbar navbar-expand-lg navbar-light" id="navbar">
        <button id="sidebar-toggler" className="sidebar-toggle" onClick={toggleSidebar}>
          <span className="sr-only">Toggle navigation</span>
        </button>
        <span className="page-title">{getPageTitle()}</span>
        <div className="navbar-right ">

          <div className="search-form">
            <div className="media">
              <i className="display-6 mdi mdi-account-card-details text-primary mr-3"></i>
              <div className="media-body mr-2">
                <p>CMS ID</p>
                <p className="h5 my-1 text-dark">{userData.cmsid}</p>
              </div>
              <i className="display-6 mdi mdi-currency-inr text-primary mr-3"></i>
              <div className="media-body mr-2">
                <p>Balance</p>
                <p className="h5 my-1 text-dark"> ₹{balance}</p>
                {/* <span className="text-success"> <i className="mdi mdi-refresh small"></i></span></p> */}
                <button onClick={fetchWalletBalance} className="btn btn-link p-0">
                  <i className="mdi mdi-refresh small"></i>
                </button>

              </div>
              <div className="wallet-controls mt-3">
                <button className="btn btn-primary mb-2 btn-pill" onClick={handleAddMoney}>
                  Add <i className="mdi mdi-currency-inr"></i>
                </button>

              </div>
            </div>

            { }
          </div>
          <ul className="nav navbar-nav">

            { }
            {userRole === 1 && (
              <li className="dropdown user-menu notifications-menu">
                <button className="dropdown-toggle nav-link" data-toggle="dropdown">
                  <i className="mdi mdi-bell-outline"></i>
                  {unreadCount > 0 && (
                    <span className="badge badge-primary navbar-badge">
                      {unreadCount}
                    </span>
                  )}
                </button>
                <ul className="dropdown-menu dropdown-menu-right">
                  <li className="dropdown-header">Notifications</li>
                  {notifications.length === 0 && (
                    <li className="dropdown-item text-center text-muted">
                      No notifications
                    </li>
                  )}

                  {notifications.slice(0, 5).map((n, index) => (
                    <li key={index}>
                      <a
                        href="javascript:void(0)"
                        className={`dropdown-item ${!n.isRead ? 'bg-light font-weight-bold' : ''}`}
                        onClick={(e) => {
                          e.preventDefault();
                          markAsRead(n.notificationId);
                        }}
                      >
                        <i className={`mdi mdi-bell-outline ${!n.isRead ? 'text-primary' : ''}`}></i>
                        <span>
                          {n.retailerName} – {n.formName}
                        </span>
                        <span className="font-size-12 d-inline-block float-right">
                          <i className="mdi mdi-clock-outline"></i>{" "}
                          {n.createdAt ? new Date(n.createdAt).toLocaleTimeString() : 'N/A'}
                        </span>
                      </a>
                    </li>
                  ))}

                  <li className="dropdown-footer">
                    <Link to="/dashboard/notifications" className="text-center dropdown-item">
                      View All
                    </Link>
                  </li>
                </ul>
              </li>
            )}
            <li className="dropdown user-menu">
              <button className="dropdown-toggle nav-link" data-toggle="dropdown">
                <span className="d-none d-lg-inline-block">{Name}</span>
              </button>
              <ul className="dropdown-menu dropdown-menu-right">
                <li>
                  <Link className='dropdown-link-item' to='/dashboard/user-profile'>
                    <i className="mdi mdi-account-outline"></i>
                    <span className="nav-text">My Profile</span>
                  </Link>
                </li>
                <li className="dropdown-footer">
                  <Link className='dropdown-link-item' to="/" onClick={handleLogout}> <i className="mdi mdi-logout"></i> Log Out </Link>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </nav>
    </header>
  );
};

export default Headerdash;
